import { useCallback, useEffect, useState } from 'react';
/**
 * Generic data-fetching hook.
 * Handles loading state, error parsing, and refetch.
 */
export function useApi(url, options = {}) {
    const { autoFetch = true } = options;
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(autoFetch);
    const [error, setError] = useState(null);
    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await fetch(url, { credentials: 'include' });
            if (!response.ok) {
                let msg = `Request failed (${response.status})`;
                try {
                    const body = await response.json();
                    if (body.message)
                        msg = body.message;
                    else if (body.error)
                        msg = body.error;
                }
                catch {
                    // ignore json parse failure
                }
                throw new Error(msg);
            }
            const json = await response.json();
            setData(json);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'An error occurred');
        }
        finally {
            setLoading(false);
        }
    }, [url]);
    useEffect(() => {
        if (autoFetch) {
            void fetchData();
        }
    }, [autoFetch, fetchData]);
    return { data, loading, error, refetch: fetchData };
}
//# sourceMappingURL=useApi.js.map